import React from 'react'
// import { Link } from "gatsby";
import { Heading } from 'components/Heading'
import { Link } from 'components/Link'
import { Container, Row, Col } from 'components/Layout'
import { CallToAction } from 'components/CallToAction'
import SectionTitle from 'components/SectionTitle'
import { Button2 as Button } from 'components/Button'
import VintageBox from 'components/VintageBox'
import { prepareData } from 'utils/googleData'
import { FileSearchOutlined as FaMapMarkedAlt } from '@ant-design/icons'
import { heading, section } from '../classes'
import { CloudDownloadOutlined as FiDownloadCloud } from '@ant-design/icons'
// import Banner3SectionWrapper from "./banner3.style";
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import ProjectItemWrapper from './pillars.style'
import { Projects } from 'components/NotProductIcons'
export function Pillars(props) {
    const {
        enable,
        title,
        subtitle,
        video,
        description,
        cta,
        direction,
        style,
        gatsbyImage,
        features,
        gatsbyTransformed,
    } = prepareData({ props })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const projectsIcon = './images/projects.svg'

    const cxImage = './images/cx.svg'
    const hcmImage = './images/hcm.svg'
    const biepmImage = './images/biepm.svg'
    const erpImage = './images/erp.svg'
    const bgColor = '#0081AA'
    return (
        <ProjectItemWrapper id="projects">
            <Container>
                <Row>
                    <div className="mx-auto w-full px-[5%] text-center">
                        <SectionTitle className="section-title" leftAlign={true} UniWidth="75%">
                            <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
                        </SectionTitle>
                    </div>
                </Row>
                <Row>
                    <div class="relative mb-8 flex w-full flex-wrap before:absolute before:right-[-0.5rem] before:bottom-0 before:bg-[url('./images/background.svg')] before:content-[''] md:before:content-none">
                        {features?.length > 0 &&
                            features.map((feature) => {
                                const { title, url, subtitle } = feature
                                return (
                                    <Col sm={12} md={6} lg={3}>
                                        <Link to={url}>
                                            <div className="bg-gray-200 flex h-56 flex-col justify-center rounded-lg p-[12%] text-center shadow-md transition-shadow duration-200 ease-in-out hover:shadow-lg">
                                                <h3 className="text-secondary m-auto text-lg font-bold">{title}</h3>
                                                <p className="m-auto text-base font-light dark:text-white">
                                                    {subtitle}
                                                </p>
                                            </div>
                                        </Link>
                                    </Col>
                                )
                            })}
                    </div>
                </Row>
                <Row>
                    <Col xs={12}>
                        <div className="bg-secondary-light flex flex-col items-center justify-center rounded-lg p-4 transition duration-200 ease-in-out sm:flex-row">
                            <div className="mb-4 flex w-full justify-center sm:mb-0 sm:w-auto">
                                <CallToAction
                                    to={cta?.url}
                                    type="secondary"
                                    className="inline-flex items-center justify-center whitespace-nowrap rounded bg-gradient-to-r from-[#00b39f] via-[#00b39f] to-[#00b39f] px-4 py-2 text-center font-medium uppercase !leading-none text-white outline-none transition-[colors,opacity] duration-200"
                                >
                                    <Projects />
                                    &nbsp;{cta?.label}
                                </CallToAction>
                            </div>
                            <p
                                className="text-gray-400 mx-4 my-0 w-full text-center text-base transition duration-200 ease-in-out sm:mx-16 sm:w-auto"
                                dangerouslySetInnerHTML={{ __html: description }}
                            ></p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </ProjectItemWrapper>
    )
}

export default Pillars
